import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root'
})
export class AppAuthGuard implements CanActivate {
  constructor(private readonly msalService: MsalService, private readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const expectedRoles: string[] = route.data['roles'];
    const account = this.msalService.instance.getActiveAccount();

    if (account && account.idTokenClaims) {
      let roles: string[] = account.idTokenClaims['roles'] || [];
      roles = roles.flatMap(role => role.split(','));
      const hasRole = roles.some((role) => expectedRoles.includes(role));

      if (hasRole) {
        return true;
      } else {
        this.router.navigate(['/errorpage']);
        return false;
      }
    } else {
      return false;
    }
  }
}
